import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Copy Fill
 */

export default function CopyFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <rect height="11" rx="2" width="9" x="6" y="1" />
      <path d="M3 15H8.4C9.28366 15 10 14.2837 10 13.4C10 13.1791 9.82091 13 9.6 13H8C6.34315 13 5 11.6569 5 10V4.5C5 4.22386 4.77614 4 4.5 4H3C1.89543 4 1 4.89543 1 6V13C1 14.1046 1.89543 15 3 15Z" />
    </Icon>
  );
}
